import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { GraduationCap, MessagesSquare, MapPin, Clock } from 'lucide-react';
import { fmtRange, fmtTime } from './TrainingScheduleModal';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Dashboard: "You're booked for training" — one card per upcoming session the user is on.
export default function TrainingScheduledCard() {
  const [sessions, setSessions] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    axios.get(`${API}/training-sessions/my`, { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } })
      .then((r) => setSessions(r.data.sessions || [])).catch(() => setSessions([]));
  }, []);
  if (!sessions.length) return null;
  return (
    <div className="space-y-3" data-testid="training-scheduled-cards">
      {sessions.map((s) => (
        <div key={s.id} className="rounded-xl border border-violet-300 bg-white border-l-4 border-l-violet-600 shadow-sm p-4 flex flex-col sm:flex-row sm:items-center gap-3" data-testid={`training-card-${s.id}`}>
          <GraduationCap className="w-7 h-7 shrink-0 text-violet-700" />
          <div className="flex-1 min-w-0">
            <p className="font-bold text-slate-900" data-testid={`training-card-title-${s.id}`}>
              {s.today ? 'Training today' : "You're booked for training"} — {s.provider_name}{s.contact ? <span className="text-slate-500 font-normal text-sm"> ({s.contact})</span> : null}
            </p>
            <p className="text-sm text-slate-700 mt-0.5 flex flex-wrap items-center gap-x-3 gap-y-0.5">
              <span className="font-semibold" data-testid={`training-card-dates-${s.id}`}>{fmtRange(s.start_date, s.end_date)}{s.days > 1 ? ` (${s.days} days)` : ''}</span>
              {s.start_time && <span className="flex items-center gap-1 text-slate-500"><Clock className="w-3.5 h-3.5" /> {fmtTime(s.start_time)}</span>}
              {s.location && <span className="flex items-center gap-1 text-slate-500"><MapPin className="w-3.5 h-3.5" /> {s.location}</span>}
            </p>
            {(s.courses?.length > 0 || s.all_courses?.length > 0) && (
              <div className="flex flex-wrap gap-1 mt-1.5" data-testid={`training-card-courses-${s.id}`}>
                {(s.courses?.length ? s.courses : s.all_courses.map((l) => ({ label: l }))).map((c, i) => (
                  <span key={i} className="text-[11px] px-2 py-0.5 rounded-full bg-violet-50 text-violet-900 border border-violet-200">{c.label}</span>
                ))}
              </div>
            )}
            {s.notes && <p className="text-xs text-slate-600 mt-1.5">{s.notes}</p>}
          </div>
          {s.thread_id && (
            <button onClick={() => navigate(`/dispatch-chat?thread=${s.thread_id}`)} className="shrink-0 px-4 py-2 rounded-lg text-sm font-semibold text-white bg-violet-600 hover:bg-violet-500 shadow-sm flex items-center gap-1.5" data-testid={`training-card-chat-${s.id}`}>
              <MessagesSquare className="w-4 h-4" /> Training chat
            </button>
          )}
        </div>
      ))}
    </div>
  );
}
